<template>

  <!--顶部导航栏 -->
  <a-layout-header class="admin-header">

    <!--logo -->
    <admin-header-title/>

    <div class="title">
      <h1>
        {{user.buildName}}
      </h1>
    </div>
    <!--用户相关 -->
    <admin-user/>

  </a-layout-header>

</template>
<script setup>
import userStore from "@/stores/user"
let user = userStore()
console.log(user)

</script>
<style scoped lang="scss">

/*
  顶部当导航栏
*/
.admin-header {

  @include flex-center; //flex上下居中
  justify-content: space-between;

  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  overflow: hidden;

  width: 100%;
  height: $admin-header-height;


  padding: 0;

  background-color: $bg-color;
  box-shadow: $shadow;

}

.title {
  transition: all 0.2s ease;
  font-family: Mini, PingFang SC, -apple-system, BlinkMacSystemFont, Segoe UI, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", Segoe UI Symbol !important;
  letter-spacing: 1px;

  h1 {
    font-size: 18px;
    font-family: Mini;
    font-weight: bold;
    white-space: nowrap;
    margin: 0;
    text-align: center;
  }
}
</style>
